export const bedTypesList = {
    BED_TYPE_PENDING  : 'BED_TYPE_PENDING',
    BED_TYPE_FULFILLED: 'BED_TYPE_FULFILLED',
    BED_TYPE_REJECTED : 'BED_TYPE_REJECTED',
};